import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

export const RoundVotes = ({ data, rounds }) => {
    const maxRounds =
        rounds?.filter(PULSE.app.common.match.isNonFinalRound).length ?? 0;

    const seasonHasOr =
        rounds?.filter((item) => item.name.includes('Opening')).length ?? 0;

    return (
        <div className="brownlow-round-votes">
            {data &&
                [...Array(Number(maxRounds)).keys()].map((round, i) => {
                    const roundId = seasonHasOr === 0 ? round + 1 : i;
                    const roundData = data[`round${roundId}`];

                    const votes = roundData?.actual;
                    const bye = votes === 'B';
                    const notPlayed = votes === 'NP';

                    return (
                        <div
                            key={i}
                            className={classNames(
                                'brownlow-round-votes__round-container',
                                {
                                    'brownlow-round-votes__round-container--bye':
                                        bye,
                                    'brownlow-round-votes__round-container--ineligible':
                                        !bye && !data.player.eligible && votes,
                                    'brownlow-round-votes__round-container--empty':
                                        !bye && !votes,
                                    'brownlow-round-votes__round-container--not-played':
                                        votes === 'NP'
                                }
                            )}
                        >
                            {bye ? 'B' : !notPlayed ? votes ?? '' : ''}
                        </div>
                    );
                })}
        </div>
    );
};

RoundVotes.propTypes = {
    data: PropTypes.any.isRequired,
    rounds: PropTypes.array.isRequired
};
